import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';

import Loading from '../components/Loading';
import API from '../api/ApiTool';

const styles = {
  actions: {
    cursor: 'pointer',
    marginTop: '12px',
    color: '#3b82f6'
  },
};

function dynamicSort(property) {
  var sortOrder = 1;
  if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }
  return function (a, b) {
    if (property === 'last_login') {
      const dateA = new Date(a[property]);
      const dateB = new Date(b[property]);

      var resultOfDates = (dateA < dateB) ? -1 : (dateA > dateB) ? 1 : 0;
      return resultOfDates * sortOrder;
    }

    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}

const UsersTable = (props) => {
  return (
    <div>
      <Table style={{backgroundColor: "#0f172a"}}>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={props.property === 'company_name'}
                direction={props.getDirection('company_name')}
                onClick={() => props.handleSort('company_name')}
              >
                Company
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'username'}
                direction={props.getDirection('username')}
                onClick={() => props.handleSort('username')}
              >
                Username
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'calls_in_progress'}
                direction={props.getDirection('calls_in_progress')}
                onClick={() => props.handleSort('calls_in_progress')}
              >
                Calls in progress
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'last_login'}
                direction={props.getDirection('last_login')}
                onClick={() => props.handleSort('last_login')}
              >
                Last login
              </TableSortLabel>
            </TableCell>
            <TableCell>
              Impersonation
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.users.map((user, i) => {
            return (
              <TableRow
                key={i}
              >
                <TableCell
                    style={styles.actions}
                    onClick={() => props.companyDetail(user.company_id, props.push)}
                  >
                    {user.company_name}
                </TableCell>
                <TableCell>{user.username}</TableCell>
                <TableCell>{user.calls_in_progress}</TableCell>
                <TableCell>
                  <Moment format="YYYY/MM/DD">
                    {user.last_login}
                  </Moment>
                </TableCell>
                <TableCell
                  style={styles.actions}
                  onClick={()=> window.open(
                    `https://app.brandedbridgeline.com/app/#/users/view-as/${user.company_id}/`, '_blank'
                  )}
                >{`https://app.brandedbridgeline.com/app/#/users/view-as/${user.company_id}/`}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};


class OnlineUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      loggedInTodaySelected: false,
      property: 'company_name',
      order: 'asc'
    };
  }

  fetchData() {
    const loggedInToday = this.state.loggedInTodaySelected;
    const property = this.state.property;

    this.setState({ loading: true });

    API.GET(`/accounts/online-users/?today=${loggedInToday}`)
      .then(response => response.json())
      .then(data => {console.log(' received' , data); this.setState({ data: data.users.sort(dynamicSort(property)) })})      
      .then(() => this.setState({ loading: false }))
  }

  componentDidMount() {
    this.fetchData();
  }

  companyDetail(id, push) {
    push(`/company-detail/${id}`);
  }

  loggedInToday(event) {
    let currentValue = this.state.loggedInTodaySelected;
    this.setState({ loggedInTodaySelected: !currentValue }, () => {
      this.fetchData();
    });
  }

  handleSort(property) {
    if (property === this.state.property && this.state.order === 'asc') {
      this.setState({ order: 'desc' }, () => {
        const data = this.state.data;
        const sortedData = data.sort(dynamicSort('-' + property));
        this.setState({ data: sortedData });
      });
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      this.setState({ order: 'asc' }, () => {
        const data = this.state.data;
        const sortedData = data.sort(dynamicSort(property));
        this.setState({ data: sortedData });
      });
    }
    else {
      this.setState({ property: property }, () => {
        this.setState({ order: 'asc' }, () => {
          const data = this.state.data;
          const sortedData = data.sort(dynamicSort(property));
          this.setState({ data: sortedData });
        });
      });
    }
  }

  getDirection(property) {
    let order = 'asc';
    if (property === this.state.property && this.state.order === 'asc') {
      order = 'asc';
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      order = 'desc';
    }
    return order;
  }

  render() {
    const { data, loading } = this.state;

    if (loading) {
      return (
        <Loading />
      );
    }

    return (
      <div>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.loggedInTodaySelected}
                onChange={() => this.loggedInToday()}
                value={''}
              />
            }
            label="Logged in today"
          />
        </FormGroup>
        <UsersTable
          data={data}
          push={this.props.history.push}
          companyDetail={this.companyDetail.bind(this)}
          users={data}
          handleSort={this.handleSort.bind(this)}
          getDirection={this.getDirection.bind(this)}
          property={this.state.property}
        />
      </div>
    );
  }
}

export default withRouter(OnlineUsers);



// WEBPACK FOOTER //
// ./src/pages/OnlineUsers.js